import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_ed2227e8-f42f-486d-80b3-32e833e48098/artifacts/o750zne6_72B3D45F-1688-469F-935E-BB6BB3789CC9.png";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="min-h-screen bg-[#050B14] text-white flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-lg text-center">
        <Link to="/" className="inline-flex items-center gap-3 mb-12">
          <img src={LOGO} alt="Capital Shield" className="h-11 w-11 object-contain" />
          <div className="text-left">
            <div className="font-display text-lg font-bold tracking-wide">CAPITAL SHIELD</div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-[#9BD0E8]">Sealing · Snow Removal</div>
          </div>
        </Link>
        <div className="bg-[#0B1B3D] border border-white/10 p-10">
          <XCircle size={48} className="text-white/50 mx-auto mb-6" />
          <div className="hairline mb-4">Checkout Cancelled</div>
          <h1 className="font-display text-2xl font-bold mb-3">No charge was made.</h1>
          <p className="text-white/65 text-sm max-w-sm mx-auto mb-8">
            You can head back to the pricing page and complete your booking anytime.
          </p>
          <Link
            to="/#pricing"
            data-testid="cancel-back-pricing"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#C9A24B] hover:bg-[#E0B962] text-[#050B14] font-semibold text-sm tracking-wide transition-colors"
          >
            Back to pricing
          </Link>
        </div>
      </div>
    </main>
  );
}
